import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;
const id = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const creatorId = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const firmId =
  JSON.parse(localStorage.getItem("authUser"))?.response?.adminId ||
  JSON.parse(localStorage.getItem("authUser"))?.response?.firmId;
const Role = JSON.parse(localStorage.getItem("authUser"))?.response?.role;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);


// 🔥 GET ALL
export const getPermissionsApi = async(params={})=>{
  try{
    const filteredParams = Object.fromEntries( Object.entries(params) .filter(([_,v])=>v!=="" && v!==undefined) );
    const res = await axiosInstance.get( "/permissions", { params:filteredParams, } );
    return res.data;
  }catch(error){
    throw error;
  }
};

// 🔥 DESIGNATION PERMISSIONS
export const getDesignationPermissionsApi = async(designationId)=>{
  try{
    const res = await axiosInstance.get( `/permissions/designation/${designationId}` );
    return res.data;
  }catch(error){
    throw error;
  }
};

// 🔥 UPDATE DESIGNATION PERMISSIONS
export const updateDesignationPermissionsApi = async( designationId, data )=>{
  try{
    const res = await axiosInstance.put( `/permissions/designation/${designationId}`, data );
    return res.data;
  }catch(error){
    throw error;
  }
};

// 🔥 USER OVERRIDES
export const getUserOverridesApi = async(userId)=>{
  try{
    const res = await axiosInstance.get( `/permissions/user/${userId}` );
    return res.data;
  }catch(error){
    throw error;
  }
};

// 🔥 UPDATE USER OVERRIDES
export const updateUserOverridesApi = async( userId, data )=>{
  try{
    const res = await axiosInstance.put( `/permissions/user/${userId}`, data );
    return res.data;
  }catch(error){
    throw error;
  }
};

// 🔥 EFFECTIVE
export const getEffectivePermissionsApi = async(userId)=>{
  try{
    const res = await axiosInstance.get( `/permissions/effective/${userId}` );
    return res.data;
  }catch(error){
    throw error;
  }
};

export const getPermissionByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/permissions/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const createPermissionApi = async (body) => {
  try {
    const res = await axiosInstance.post("/permissions", body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updatePermissionApi = async (id, body) => {
  try {
    const res = await axiosInstance.put(`/permissions/${id}`, body);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deletePermissionApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/permissions/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
export default axiosInstance;


